import { RosterEntryDrawer } from '@/components/RosterEntryDrawer'
import { QuickStartAircraftDrawer } from './QuickStartAircraftDrawer'
import { QuickStartCrewDrawer } from './QuickStartCrewDrawer'
import { QuickStartOwnerDetailsDrawer } from './QuickStartOwnerDetailsDrawer'
import { QuickStartPaxDrawer } from './QuickStartPaxDrawer'
import { AllSetDialog } from './AllSetDialog'
import type { StepId } from './useQuickStartGuide'

interface QuickStartStepDrawersProps {
  activeDrawer: StepId | null
  onDrawerClose: () => void
  showAllSetDialog: boolean
  onAllSetClose: () => void
}

export function QuickStartStepDrawers({
  activeDrawer,
  onDrawerClose,
  showAllSetDialog,
  onAllSetClose,
}: QuickStartStepDrawersProps) {
  return (
    <>
      <QuickStartOwnerDetailsDrawer
        isOpen={activeDrawer === 'owner-details'}
        onClose={onDrawerClose}
      />
      <QuickStartAircraftDrawer
        isOpen={activeDrawer === 'aircraft'}
        onClose={onDrawerClose}
      />
      <QuickStartCrewDrawer
        isOpen={activeDrawer === 'crew'}
        onClose={onDrawerClose}
      />
      <RosterEntryDrawer
        open={activeDrawer === 'roster-entry'}
        onOpenChange={(open) => !open && onDrawerClose()}
        quickStartMode={true}
      />
      <QuickStartPaxDrawer
        isOpen={activeDrawer === 'passenger'}
        onClose={onDrawerClose}
      />
      <AllSetDialog
        isOpen={showAllSetDialog}
        onClose={onAllSetClose}
      />
    </>
  )
}
